import React, { useState, useEffect, useMemo } from 'react';
import PageHeading from '../../components/PageHeading';
import { BankOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Button, Input, message, Table } from 'antd';
import axiosInstance from '../../utils/axios';

const Theatre = () => {
  const navigate = useNavigate();
  const [theatres, setTheatres] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.get("theatre-management/theatre/");
			setTheatres(response.data);
		} catch (error) {
			message.error("Failed to fetch theatre");
		} finally {
			setLoading(false);
		}
	};

  const filteredTheatres = useMemo(() => {
    return theatres.filter(item =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, theatres]);

  const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Owner',
			dataIndex: 'owner',
			key: 'owner',
		},
  	{
			title: 'State',
			dataIndex: 'state',
			key: 'state',
			render: (_, record) => <>{record.state?.name || '—'}</>,
		},
    {
			title: 'District',
			dataIndex: 'district',
			key: 'district',
			render: (_, record) => <>{record.district?.name || '—'}</>,
		},
    {
			title: 'Total Screens',
			dataIndex: 'total_screens',
			key: 'total_screens',
		},
    {
			title: 'Phone Number',
			dataIndex: 'phone_number',
			key: 'phone_number',
		},
		{
			title: 'Action',
			dataIndex: '',
			key: 'actions',
			render: (_, record) => record.restricted ? null : (
				<>
					<Button type="link" icon={<EditOutlined />} onClick={() => navigate(`/admin/theatre/${record.id}`)}/>
				</>
			)
		},
	];

  return (
		<div className='dashboard'>
			<PageHeading name="Theatres" icon={<BankOutlined/>} />

			<div style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: '12px',
				alignItems: 'center',
				justifyContent: 'space-between',
				marginBottom: 16
			}}>
				<Input
					placeholder="Search here"
					prefix={<SearchOutlined />}
					style={{ width: "190px" }}
					onChange={(e) => setSearch(e.target.value)}
				/>
				<Button type="primary" onClick={() => navigate('/admin/theatre/add-new')}>Add new</Button>
			</div>

      <Table
				dataSource={filteredTheatres}
				loading={loading}
				columns={columns}
				rowKey="id"
        scroll={{ x: 'max-content' }}
        pagination
			/>
    </div>
  )
}

export default Theatre